import { Capacitor } from '@capacitor/core';
import { isAndroidApp } from '../notifications/androidPush';

export function browserPlatform(target = window) {
  if (Capacitor.isNativePlatform() || target.location.protocol === 'capacitor:' || isAndroidApp()
    || target.navigator.standalone || target.matchMedia?.('(display-mode: standalone)').matches
    || target.matchMedia?.('(display-mode: fullscreen)').matches) return null;
  const ua = target.navigator.userAgent;
  if (/iPad|iPhone|iPod/.test(ua) || (target.navigator.platform === 'MacIntel' && target.navigator.maxTouchPoints > 1)) return 'ios';
  return /Android/.test(ua) ? 'android' : null;
}

export function isSafari(target = window) {
  const ua = target.navigator.userAgent;
  return /Version\/[\d.]+.*Safari\//.test(ua) && !/CriOS|FxiOS|EdgiOS|OPiOS/.test(ua);
}
